import { Row, Tabs } from 'antd';
import { useState } from 'react';
import { WidgetsCard } from './WidgetsCard';
import React from 'react';
const { TabPane } = Tabs;
const Widgets = (props) => {
	const { setActionCard, activeKey, setActiveKey, activeFilter, data, myArray, filterTabData } = props;

	const [tabPosition] = useState('left');

	return (
		<div>
			{!activeFilter ? (
				<Tabs
					activeKey={activeKey}
					tabPosition={tabPosition}
					onChange={(key) => {
						setActiveKey(key);
						filterTabData(key);
					}}
					type="card"
				>
					{myArray && (
						<TabPane tab={<span>All</span>} key="1">
							<Row gutter={24} className="my-2">
								{myArray?.map((cardItem, i) => {
									return (
										<WidgetsCard
											item={cardItem && cardItem}
											key={i}
											setActionCard={setActionCard}
										/>
									);
								})}
							</Row>
						</TabPane>
					)}
					{data.widgetTags?.map((item, i) => {
						return (
							<TabPane
								tab={
									<span>
										{/* <img src={`${item.module_icon}`} alt="img" className="mr-2" /> */}
										{item.module_name}
									</span>
								}
								key={item.module_id}
							>
								<Row gutter={24} className="my-2">
									{myArray.map((cardItem, i) => {
										return (
											<WidgetsCard
												item={cardItem && cardItem}
												key={i}
												setActionCard={setActionCard}
											/>
										);
									})}
								</Row>
							</TabPane>
						);
					})}
				</Tabs>
			) : (
				<Row gutter={24}>
					{myArray.map((cardItem, i) => {
						return <WidgetsCard item={cardItem && cardItem} key={i} setActionCard={setActionCard} />;
					})}
				</Row>
			)}
		</div>
	);
};
export default Widgets;
